import {useParams} from 'react-router-dom'
import CampaignScreens from 'src/app/modules/campaign/CampaignScreens'
import {
  useGetSalesPromoDetailParticipantDetail,
  useSalesPromoParticipantPrizeList,
} from 'src/app/modules/campaign/providers/SalesPromo.provider'

export function useSalesPromoTabDetailParticipantDetail() {
  const {id, participantId} = useParams<{id: string; participantId: string}>()
  const participantDetail = useGetSalesPromoDetailParticipantDetail(id, participantId)
  const participantPrizeList = useSalesPromoParticipantPrizeList(id, participantId)

  const breadcrumbs = [
    {
      isActive: false,
      path: [CampaignScreens.LIST_SALES_PROMO.PATH].join(),
      title: 'Sales Promotion',
    },
    {
      isActive: false,
      path: CampaignScreens.DETAIL_SALES_PROMO.PATH.replace(':id', id).replace(
        ':path',
        'participant'
      ),
      title: 'Detail',
    },
    {isActive: false, path: '', title: '', isSeparator: true},
  ]

  return {
    breadcrumbs,
    participantDetail,
    participantPrizeList,
  }
}
